<mat-card>
  <mat-card-header>
    <mat-card-title>Gestión de Servicio de Gasto</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching && item != null">

      <mat-expansion-panel [expanded]="true" hideToggle="true">

        <mat-expansion-panel-header>
          <mat-panel-title>
            Datos del Servicio de Gasto
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-container *ngIf="canEdit">

          <form [formGroup]="formGroup">

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Código*</mat-label>
                  <input matInput formControlName="Codigo" (keyup.enter)="onGuardar()" maxlength="100">
                  <mat-icon matSuffix>search</mat-icon>
                  <mat-error *ngIf="!formGroup.controls['Codigo'].valid && formGroup.controls['Codigo'].touched">
                    {{ getErrorCodigo() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nombre*</mat-label>
                  <input matInput formControlName="Nombre" (keyup.enter)="onGuardar()" maxlength="200">
                  <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                    {{ getErrorNombre() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isCategoriaGastoSearching">Categoría*</mat-label>
                    <mat-label *ngIf="isCategoriaGastoSearching">Cargando...</mat-label>
                    <mat-select formControlName="CategoriaGastoId">
                        <mat-option *ngFor="let s of categoriaGastoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!formGroup.controls['CategoriaGastoId'].valid && formGroup.controls['CategoriaGastoId'].touched">
                        {{ getErrorCategoriaGastoId() }}
                    </mat-error>
                </mat-form-field>
              </div> -->
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isServicioGrupoSearching">Grupo*</mat-label>
                    <mat-label *ngIf="isServicioGrupoSearching">Cargando...</mat-label>
                    <mat-select formControlName="ServicioGrupoId">
                        <mat-option *ngFor="let s of servicioGrupoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!formGroup.controls['ServicioGrupoId'].valid && formGroup.controls['ServicioGrupoId'].touched">
                        {{ getErrorServicioGrupoId() }}
                    </mat-error>
                </mat-form-field>
              </div>

            </div>

          </form>

          <div fxLayout="row stretch" fxLayout.xs="column">
            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-checkbox [(ngModel)]="item.Activo" (keyup.enter)="onGuardar()" color="primary">Activo</mat-checkbox> 
            </div>
          </div>

        </ng-container>

        <ng-container *ngIf="!canEdit">

          <div fxLayout="row stretch" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Código</b>: {{item.Codigo}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nombre</b>: {{item.Nombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <!-- <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Categoría</b>: {{item.CategoriaGastoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div> -->
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Grupo</b>: {{item.ServicioGrupoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Activo</b>: {{item.Activo ? 'Sí' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </ng-container>

      </mat-expansion-panel>

      <br>

      <mat-expansion-panel [expanded]="true" hideToggle="true">

        <mat-expansion-panel-header>
          <mat-panel-title>
            Tipos de Gastos Asociados por {{'Comunidad' | translate}}
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-container *ngIf="canEdit">

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=45 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}*</mat-label>
                <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                <mat-select [(ngModel)]="comunidadSeleccionada" [compareWith]="compareComunidades" (selectionChange)="onComunidadSelection()">
                  <mat-option *ngFor="let s of comunidadList" [value]="s">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=45 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isTipoGastoComunidadSearching">Tipos de Gasto*</mat-label>
                <mat-label *ngIf="isTipoGastoComunidadSearching">Cargando...</mat-label>
                <mat-select [(ngModel)]="tiposGastoSeleccionados" multiple [compareWith]="compareTiposGasto">
                  <mat-option *ngFor="let s of comunidadTipoGastoList" [value]="s">{{s.TipoGasto}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
      
            <div fxFlex=10 fxFlex.xs=100 class="flex-item" style="margin-top: 10px;">
              <button mat-raised-button (click)="onTipoGastoServicioAdd()" [disabled]="isSaving" color="primary" class="zb-button">Guardar</button>
            </div>
      
          </div>
      
          <hr style="margin-top: 20px; margin-bottom: 20px; width: 100%;">

        </ng-container>

        <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column">
          <mat-label *ngIf="isComunidadTipoGastoServicioSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    
          <ejs-grid #tipoGastoServicioGrid [dataSource]='comunidadTipoGastoServicioList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' 
            [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
            <e-columns>
              <e-column field='ComunidadNombre' headerText='Comunidad' width=90>
                <ng-template #headerTemplate let-data>
                  {{'Comunidad' | translate}}
                </ng-template>
              </e-column>
              <e-column headerText='Tipos de Gastos' width=200>
                <ng-template #template let-data>
                  {{ getTiposGastosConcat(data) }}
                </ng-template>
              </e-column>
              <e-column headerText='Acciones' width=90 *ngIf="canEdit">
                <ng-template #template let-data>
                  <a style="cursor: pointer; margin-right: 5px" (click)="onTipoGastoServicioDelete(data)" title="Eliminar"><i class="fa fa-trash fa-1x"></i></a>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>

      </mat-expansion-panel>

    </div>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">
    <div fxLayout="row stretch" fxLayout.xs="column">
      <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
      <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">{{canEdit ? 'Cancelar' : 'Cerrar'}}</button>
      <button mat-raised-button (click)="onDelete()" *ngIf="canDelete && item != null && item.Id > 0" [disabled]="isSaving" color="warn" class="zb-button">
        {{ isDeleting ? 'Eliminando...' : 'Eliminar' }}
      </button>
    </div>
  </mat-card-actions>

</mat-card>